import { ResponseData, THomeBannerInfo } from "@/typings";
import { TProductsResponse, TBrandLogoResponse } from "@/typings/about";
import { fetchYooFindsApi } from "@/utils/fetch";
import { GetActivityBannerArgs, GetProductListParams } from "./interface";
import { getUri } from "@/utils/url";

export async function fetchActivityBanner({
  params,
  headers,
}: GetActivityBannerArgs) {
  return await fetchYooFindsApi<ResponseData<THomeBannerInfo[]>>(
    getUri("api/adv/ad-streamer", params),
    {
      cache: "no-store",
      headers,
    }
  );
}

export async function fetchBrandLogo() {
  return await fetchYooFindsApi<ResponseData<TBrandLogoResponse[]>>(
    "/api/brand/logoList"
  );
}

export async function fetchProducts(params: GetProductListParams) {
  return await fetchYooFindsApi<ResponseData<TProductsResponse>>(
    `api/v2/products/recommend/${params.recommendType}`
  );
}
